import { Injectable } from "@angular/core";
import { Action } from "@ngrx/store";
import { ActionWithPayload } from "@obg/ngrx-utils";
import { ChangePasswordModel } from "@obg/ngx.common/types";
import { AppError } from "@obg/ngx.core";

export const ACTION_PREFIX = "[Account Settings]";
export const ACCOUNT_SETTINGS_ACTION_TYPE = {
	changePassword: `${ACTION_PREFIX} Change Password`,
	changePasswordSuccess: `${ACTION_PREFIX} Change Password Success`,
	changePasswordFail: `${ACTION_PREFIX} Change Password Fail`,
};

@Injectable({
	providedIn: "root",
})
/**
 * @deprecated - [fabric-deprecated] - Use AccountSettingsService from app-account mfe instead
 */
export class AccountSettingsAction {
	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.dispatch(AccountAppCommand_INTERNAL.ChangePassword) instead
	 */
	changePassword(payload: ChangePasswordModel): ActionWithPayload {
		return {
			type: ACCOUNT_SETTINGS_ACTION_TYPE.changePassword,
			payload,
		};
	}
	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.dispatch(AccountAppCommand_INTERNAL.ChangePassword) instead
	 */
	changePasswordSuccess(): Action {
		return {
			type: ACCOUNT_SETTINGS_ACTION_TYPE.changePasswordSuccess,
		};
	}
	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.dispatch(AccountAppCommand_INTERNAL.ChangePassword) instead
	 */
	changePasswordFail(payload: AppError): ActionWithPayload {
		return {
			type: ACCOUNT_SETTINGS_ACTION_TYPE.changePasswordFail,
			payload,
		};
	}
}
